import { Grid } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";

import {
  EnergyKpis,
  OverviewHeader,
  OverviewTemperatureKpis,
  useOverviewSensors,
  useOverviewTemperatures,
} from "@utilifeed/components/propai";
import { useGetFlexStations } from "@core/apis/PropAI";
import { useSubstationAddress } from "@core/apis/shared/hooks";

export const OverviewPage = () => {
  const { substationId } = Route.useParams();
  const routeContextAddress = Route.useRouteContext()?.substation?.install_address?.["street"] as
    | string
    | undefined;

  const { data: flexStations } = useGetFlexStations(substationId);
  const flexStationUid = flexStations?.[0]?.uid ?? null;

  const { address } = useSubstationAddress(substationId, routeContextAddress);
  const { data: temperatures, isLoading: tempsLoading } = useOverviewTemperatures(substationId, {
    flexStationUid,
  });
  const { data: sensorCounts, isLoading: sensorsLoading } = useOverviewSensors(substationId);

  return (
    <Grid container spacing={2} p={4}>
      <Grid item xs={12}>
        <OverviewHeader address={address} sensorCounts={sensorCounts} isLoading={sensorsLoading} />
      </Grid>
      <Grid item xs={12}>
        <OverviewTemperatureKpis temperatures={temperatures} isLoading={tempsLoading} />
      </Grid>
      <Grid item xs={12}>
        <EnergyKpis substationId={substationId} />
      </Grid>
    </Grid>
  );
};

export const Route = createFileRoute("/$organizationId/properties/$substationId/overview")({
  component: OverviewPage,
});
